import { FabulousInternal, type FabulousProps } from './Fabulous'
import { FabulousMenu } from './Fabulous.Menu'

/**
 * Fabulous
 *
 * Fabulous button for variants: 'mobile' and 'tablet' leaning on our
 * internal FAB (Floating Action Button).
 *
 * Place any Icon from @dhl-ui/icons inside it and select your correct
 * size and position.
 * When using the `Fabulous.Menu` please make sure to also lean on the
 * hook `useFabulousMenu` to be able to close it from inside its menu.
 *
 * Documentation:
 * - [Fabulous](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/constructs-fabulous--docs)
 * - [Confluence](https://dhlbnl.atlassian.net/wiki/spaces/DS/pages/4803788813/Floating+Action+Button)
 */
const Fabulous = (props: FabulousProps) => <FabulousInternal {...props} />

Fabulous.Menu = FabulousMenu

export { Fabulous, type FabulousProps }
export { useFabulousMenu } from './context'
